import React from 'react';
import { BaseText } from './BaseText';
import { defineFontSettings } from './fontSettings';

export const Body5 = (props) => {
  const { children } = props;
  const fontSettings = defineFontSettings(
    { fontSize: '12px', lineHeight: '18px' },
    { fontSize: '14px', lineHeight: '18px' }
  );
  return (
    <BaseText fontSettings={fontSettings} {...props}>
      {children}
    </BaseText>
  );
};
